// eslint-disable-next-line no-undef
export const gtmDataLayer = window && window.dataLayer ? window.dataLayer : []
